module.exports = require("tty");


//////////////////
// WEBPACK FOOTER
// external "tty"
// module id = 261
// module chunks = 1